module.exports = __webpack_public_path__ + "static/titan-5da84d72c27f819f80779b156f002559.png";